import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardList, CheckCircle } from "lucide-react";
import AssignmentForm from "./AssignmentForm";
import { PageHeader, AppCard, AppCardContent, AppButton } from "../ui";
import { getCurrentUser } from "../../utils/auth";
import "./Assignments.scss";

const AssignmentCreatePage = () => {
  const [created, setCreated] = useState(false);
  const navigate = useNavigate();
  const assignmentsPath = getCurrentUser()?.usertype === 'instructor' ? '/i/assignments' : '/assignments';

  if (created) {
    return (
      <div className="asgn-form-page">
        <AppCard>
          <AppCardContent>
            <div className="asgn-success">
              <CheckCircle size={40} className="asgn-success__icon" />
              <h3 className="asgn-success__title">Assignment Created!</h3>
              <p className="asgn-success__text">Your coding assignment has been created successfully.</p>
              <AppButton onClick={() => navigate(assignmentsPath)}>Go to Assignments</AppButton>
            </div>
          </AppCardContent>
        </AppCard>
      </div>
    );
  }

  return (
    <div className="asgn-form-page">
      <PageHeader
        title="Create Coding Assignment"
        description="Assign coding questions to batches with randomized delivery per student."
        icon={ClipboardList}
      />
      <AssignmentForm onSuccess={() => setCreated(true)} />
    </div>
  );
};

export default AssignmentCreatePage;
